module.exports = __webpack_public_path__ + "media/images/icon_calendar_16-16-125d43b581e7786b610dc970cdb741f6.png";